import { render } from "./RemoteRack.vue?vue&type=template&id=397c44a2"
import script from "./RemoteRack.vue?vue&type=script&lang=js"
export * from "./RemoteRack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__